// extracted by mini-css-extract-plugin
export var boxItems = "_8u-1";
export var boxItemsLg = "_8u-2";
export var button = "_8u-7";
export var buttonHoverless = "_8u-9";
export var buttonLg = "_8u-8";
export var filterGroupBox = "_8u-0";
export var icon = "_8u-3";
export var iconSecondary = "_8u-6";
export var iconWrapper = "_8u-4";
export var iconWrapperLg = "_8u-5";
export var truncatedLabel = "_8u-a";